import React, { useEffect, useState, useRef } from 'react';
interface RatingCircleProps {
  score: number;
  size?: number;
  strokeWidth?: number;
  animate?: boolean;
}
export function RatingCircle({
  score,
  size = 60,
  strokeWidth = 4,
  animate = true
}: RatingCircleProps) {
  const [offset, setOffset] = useState(0);
  const circleRef = useRef<SVGCircleElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const center = size / 2;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  // Determine color based on score
  const getColor = (s: number) => {
    if (s >= 90) return '#00ff88'; // Green
    if (s >= 70) return '#00d4ff'; // Cyan
    if (s >= 50) return '#ff6b35'; // Orange
    return '#ff4444'; // Red
  };
  const color = getColor(score);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (circleRef.current) {
      observer.observe(circleRef.current);
    }
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!animate || !isVisible) {
      setOffset(circumference - score / 100 * circumference);
      return;
    }
    // Start with full offset (empty circle)
    setOffset(circumference);
    // Animate to actual score
    const targetOffset = circumference - score / 100 * circumference;
    const timer = setTimeout(() => {
      setOffset(targetOffset);
    }, 100);
    return () => clearTimeout(timer);
  }, [score, circumference, animate, isVisible]);
  return <div className="relative flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-208">
      <svg width={size} height={size} className="transform -rotate-90" data-id="element-209">
        {/* Background Circle */}
        <circle cx={center} cy={center} r={radius} fill="transparent" stroke="#2a2a3e" strokeWidth={strokeWidth} data-id="element-210" />
        {/* Progress Circle */}
        <circle ref={circleRef} cx={center} cy={center} r={radius} fill="transparent" stroke={color} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" style={{
        transition: 'stroke-dashoffset 1.5s ease-out'
      }} data-id="element-211" />
      </svg>
      <span className="absolute font-bold font-display" style={{
      color,
      fontSize: size * 0.35
    }} data-id="element-212">
        {score}
      </span>
    </div>;
}